import React, { useState, useEffect } from 'react'
import MobileModal from 'srcReact/components/common2/MobileModal'
import Modal from 'srcReact/components/common2/Modal'
import { TextArea } from 'srcReact/components/common2/TextArea'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import EmojisForRating from '../EmojisForRating'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import ReviewList from './ReviewList'

function ReviewListModal({
  mixrId,
  isMobileDevice,
  ratingData,
  currentReview,
  loading,
  isOpen,
  closeModal,
  openWriteReviewModal
}) {
  const { t } = useTranslation()

  const renderContent = () => {
    return (
      <div className={styles.reviewListWrapper}>
        <Button
          customStyle={styles.btnWriteReview}
          text={currentReview ? t('rating.review.editReview') : t('rating.review.writeReview')}
          size='large'
          handleClick={openWriteReviewModal}
        />
        <p className={styles.meta}>
          <span>{t('rating.review.reviewcount', { count: ratingData.ratings_and_reviews.review_count })}</span>
          <span>{`-`}</span>
          <span>{t('rating.mixrrating', { count: ratingData.ratings_and_reviews.rating_count })}</span>
          <span>{`-`}</span>
          <span>{`${t('rating.averageRating')}: ${ratingData.mixr_rating}/5`}</span>
        </p>
        {ratingData.ratings_and_reviews.user_ratings?.length > 0 && (
          <ReviewList mixrId={mixrId} openWriteReviewModal={openWriteReviewModal} isLoading={loading} />
        )}
      </div>
    )
  }

  return isMobileDevice ? (
    <MobileModal isOpen={isOpen} handleClose={closeModal} title={t('rating.ratingReviewTitle')}>
      {renderContent()}
    </MobileModal>
  ) : (
    <Modal isOpen={isOpen} handleClose={closeModal} title={t('rating.ratingReviewTitle')}>
      {renderContent()}
    </Modal>
  )
}

export default ReviewListModal
